<template>
  <section v-if="methods">
    <div class="text-center mb-2" v-if="show_logo">
      <b-img
        fluid
        :src="logoUrl"
        v-if="!loading"
        :alt="$t('ORGANISATION.TITLE') + ' ' + $t('NAME')"
        class="login-logo"
      ></b-img>
    </div>
    <div class="box-content" :key="reloadKey">
      <div v-if="!loading" class="form-group">
        <label class="col-form-label">{{
          $t("AUTH_METHODS.SELECT_METHOD")
        }}</label>

        <b-form-select
          :key="'selectedKey_' + selectedIndex"
          v-model="selectedIndex"
          :options="options"
        ></b-form-select>
      </div>

      <div v-if="currentSelectHasChilds">
        <b-form-select
          v-model="selectedChildIndex"
          :options="childs_options"
          class="mb-2"
        ></b-form-select>
      </div>

      <AuthPassword
        @authenticated="authenticated"
        @loading="setLoading"
        :loginInfo="loginInfo"
        v-if="loginInfo.auth_type == 'password'"
      ></AuthPassword>

      <AuthPasswordSms
        @authenticated="authenticated"
        @loading="setLoading"
        :loginInfo="loginInfo"
        v-if="loginInfo.auth_type == 'password-sms'"
      ></AuthPasswordSms>

      <AuthSefosCertificate
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo="loginInfo"
        v-if="loginInfo.auth_type == 'sefos-certificate'"
      ></AuthSefosCertificate>

      <AuthBankid
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo.sync="loginInfo"
        v-if="loginInfo.auth_method == 'bankid-se'"
      ></AuthBankid>

      <AuthFreja
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo.sync="loginInfo"
        v-if="
          loginInfo.auth_method == 'freja' || loginInfo.auth_type == 'freja-org'
        "
      ></AuthFreja>

      <AuthEFOS
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo="loginInfo"
        v-if="loginInfo.auth_type == 'EFOS'"
      ></AuthEFOS>

      <AuthNetIDAccess
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo="loginInfo"
        v-if="loginInfo.auth_method == 'net-id-access'"
      ></AuthNetIDAccess>

      <AuthNetIDEnterprise
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :loginInfo.sync="loginInfo"
        v-if="
          loginInfo.auth_method == 'net-id-enterprise' ||
          loginInfo.auth_type == 'siths'
        "
      ></AuthNetIDEnterprise>

      <AuthCustom
        @authenticated="authenticated"
        @loading="setLoading"
        @startAuthentication="startAuthentication"
        :methods="methods"
        :loginInfo.sync="loginInfo"
        v-if="showCustom"
      ></AuthCustom>

    </div>
  </section>
</template>
<script>
import AuthPassword from "./Auth/Password.vue";
import AuthPasswordSms from "./Auth/PasswordSms.vue";
import AuthSefosCertificate from "./Auth/SefosCertificate.vue";
import AuthCustom from "./Auth/Custom.vue";
import AuthFreja from "./Auth/SE/Freja.vue";
import AuthBankid from "./Auth/SE/Bankid.vue";
import AuthEFOS from "./Auth/EFOS.vue";
import AuthNetIDAccess from "./Auth/Siths/NetIDAccess.vue";
import AuthNetIDEnterprise from "./Auth/Siths/NetIDEnterprise.vue";
export default {
  components: {
    AuthEFOS,
    AuthCustom,
    AuthPassword,
    AuthPasswordSms,
    AuthFreja,
    AuthBankid,
    AuthSefosCertificate,
    AuthNetIDAccess,
    AuthNetIDEnterprise,
  },
  props: ["login", "from", "auth_uuid"],
  data() {
    return {
      test: "",
      reloadIndex: 0,
      selectedIndex: 0,
      selectedChildIndex: 0,
      childs: [],
      childs_options: [],
      loginInfo: {
        auth_type: "password",
        auth_method: "",
      },
      loading: true,
      methods: null,
      errorMessage: "",
      options: [],
      show_logo: false,
      popup: null,
      timer: null,
      popupAuth: false,
      debugmails: [],
      authId: ""
    };
  },
  methods: {
    async init() {
      if (localStorage.getItem("auth_method") != null) {
        this.loginInfo.auth_method = localStorage.getItem("auth_method");
      }
      if (localStorage.getItem("auth_type") != null) {
        this.loginInfo.auth_type = localStorage.getItem("auth_type");
      }
      if (localStorage.getItem("email") != null) {
        this.email = localStorage.getItem("email");
      }
      this.getMethods();
      this.getLogo();
    },
    async processMethods() {
      for (let ix = 0; ix < this.methods.length; ix++) {
        let method = this.methods[ix];
        let methodName = "";
        if (method.auth_type == "custom") {
          methodName = method.custom_name;
        } else {
          methodName = this.$t("AUTH_METHODS." + method.auth_type);
        }
        this.options.push({
          value: ix,
          text: methodName,
        });
        if (method.auth_type == "custom") {
          if (method.auth_method == this.loginInfo.auth_method) {
            this.selectedIndex = ix;
          }
        } else {
          if (method.auth_type == this.loginInfo.auth_type) {
            this.selectedIndex = ix;
          }
        }
      }
      if (this.selectedIndex == 0) {
        this.calculateMethods(0);
      }
      this.loading = false;
    },
    async getOldMethods() {
      let self = this;
      await this.$http
        .get(this.user.hostname + "/authenticate/methods")
        .then(function (result) {
          self.methods = [];
          let oldMethods = result.data;
          for (let ix = 0; ix < oldMethods.length; ix++) {
            let oldMethod = oldMethods[ix];
            let newMethod = {
              auth_type: oldMethod.name,
              auth_method: "",
              custom_name: "",
              loa_level: oldMethod.loa_level,
              admin_org: oldMethod.admin_org,
              childs: [],
            };
            if (oldMethod.childs.length != 0) {
              for (let ax = 0; ax < oldMethod.childs.length; ax++) {
                let oldChildMethod = oldMethod.childs[ax];
                let newChildMethod = {
                  auth_type: oldMethod.name,
                  auth_method: oldChildMethod.name,
                  custom_name: "",
                  loa_level: oldChildMethod.loa_level,
                  admin_org: oldChildMethod.admin_org,
                  childs: [],
                };
                newMethod.childs.push(newChildMethod);
              }
            }
            self.methods.push(newMethod);
          }
          self.processMethods();
        })
        .catch(function (error) {
          if(error.toString() == "Error: fail_4_4") return;
          self.loading = false;
          if (error.status) {
            self.$noty.error(self.$t(error.response));
          }
        });
    },
    async getMethods() {
      let self = this;
      await this.$http
        .get(this.user.hostname + "/authenticate/methods/list")
        .then(function (result) {
          self.methods = result.data;
          self.loading = false;
          self.processMethods();
        })
        .catch(function () {
          self.getOldMethods();
        });
    },
    async Redirect()
    {
      switch (this.teams.context.page.id) {                
        case "messages":
          this.$router.push({ name: "Messages" });       
          break;
        case "meetings":
        this.$router.push({ name: "Meetings" });
          break;
        case "files":  
        this.$router.push({ name: "FileStorage" });
          break;
      }
    },
    async startAuthentication(url) {
      try {
        let result = await this.microsoftTeams.authentication.authenticate({
          url: process.env.VUE_APP_URL + "/redirect.html?url=" + url,
          width: 600,
          height: 535,
        });
        await this.$store.dispatch(
          "user/logInfo",
          "found token :" + result.length
        );
        this.authenticated(result);
      } catch (error) {
        await this.$store.dispatch("user/logInfo", error);
        this.loading = false;
        this.reloadIndex = this.reloadIndex + 1;
        if(error.toString() == "Error: fail_4_4") return;
        this.$noty.error(this.$t("ERROR.CANNOT_LOGIN"));
      }
    },
    async authenticationResult() {      
      let self = this;
      this.$http
        .get(this.user.hostname + "/authenticate/result/" + this.auth_uuid)
        .then(function (result) {            
          if (result.data.token != undefined) {
            self.microsoftTeams.authentication.notifySuccess(result.data.token);
          } else {
            self.microsoftTeams.authentication.notifyFailure(
              "StateDoesNotMatch"
            );
          }
        })
        .catch(function () {
          self.microsoftTeams.authentication.notifyFailure(
              "StateDoesNotMatch"
            );
        });
    },
    async authenticated(token) {
      let self = this;
      if (token != undefined) {
        this.$store.dispatch("user/setToken", token);
        setTimeout(function(){ 
          self.Redirect();
        }, 1000);
      }
    },
    setLoading: function (val) {
      //this.$cookies.set("token", "", "1s", '', '',  true,  'None');
      //this.$cookies.remove("token");
      this.loading = val;
    },
    async getLogo() {
      try {
        let result = await this.$http.get(this.user.hostname + "/show-logo");        
        this.show_logo = result.data;
      } catch {
        this.show_logo = false;
      }
    },
    calculateMethods(newVal) {
      this.childs = [];
      this.childs_options = [];
      let method = this.methods[newVal];
      this.loginInfo.auth_type = method.auth_type;
      if (method.auth_type == "custom") {
        this.loginInfo.auth_method = method.auth_method;
      } else {
        if (method.childs.length == 0) {
          this.loginInfo.auth_method = method.auth_method;
        } else {
          if (method.childs.length > 1) {
            this.childs_options.push({
              value: null,
              text: this.$t("AUTH_METHODS.SELECT_EXTRA_METHOD"),
            });
            this.selectedChildIndex = null;
          }
          let found = false;
          for (let ax = 0; ax < method.childs.length; ax++) {
            let childmethod = method.childs[ax];
            this.childs.push(childmethod);
            this.childs_options.push({
              value: ax,
              text: this.$t("AUTH_METHODS." + childmethod.auth_method),
            });
            if (childmethod.auth_method == this.loginInfo.auth_method) {
              this.selectedChildIndex = ax;
              found = true;
            }
          }
          if (found == false && method.childs.length > 0) {
            this.loginInfo.auth_method = method.childs[0].auth_method;
            this.selectedChildIndex = 0;
          }
        }
      }
    },
  },
  computed: {
    showCustom() {
      if (this.loginInfo.auth_type == "custom") {
        return true;
      } else {
        if (
          this.loginInfo.auth_type == "se-eid" &&
          this.loginInfo.auth_method == ""
        ) {
          return true;
        }
        if (
          this.loginInfo.auth_type == "siths-card" &&
          this.loginInfo.auth_method == ""
        ) {
          return true;
        }
        if (
          this.loginInfo.auth_type == "EFOS" &&
          this.loginInfo.auth_method == ""
        ) {
          return true;
        }
      }
      return false;
    },
    logoUrl() {
      return this.user.hostname + "/logo";
    },
    currentSelectHasChilds() {
      return (
        !this.loading && this.methods[this.selectedIndex].childs.length != 0
      );
    },
    showChildrenSubmitDisabled() {
      return this.currentSelectHasChilds && this.loginInfo.auth_method == null;
    },
    reloadKey() {
      return "reloadKey_" + this.reloadIndex;
    },
  },
  watch: {
    selectedIndex: function (newVal) {
      this.calculateMethods(newVal);
    },
    selectedChildIndex: function (newVal) {
      if (newVal == null) {
        this.loginInfo.auth_method = "";
      } else {
        this.loginInfo.auth_method = this.childs[newVal].auth_method;
      }
    },
    "loginInfo.auth_method": function (newVal) {
      if (newVal == "null") {
        newVal = "";
      }
      localStorage.setItem("auth_method", newVal);
    },
    "loginInfo.auth_type": function (newVal) {
      localStorage.setItem("auth_type", newVal);
    },
    "loginInfo.email": function (newVal) {
      localStorage.setItem("email", newVal);
    },
  },
  mounted: async function () {
    console.log("Mounted 4.4 Login.vue");
    if (this.auth_uuid != undefined) {
      this.authenticationResult();
    } else {
      this.init();
    }
  },
};
</script>
<style></style>
